import styled from "styled-components";
import { keyframes } from "styled-components";

const Check_enter = keyframes`
0% {
  opacity: 1;
  transform: scale(1) rotateY(0deg);
 }

 50% {
  opacity: 0;
  transform: scale(.8) rotateY(180deg);
 }

 100% {
  opacity: 1;
  transform: scale(1) rotateY(360deg);
 }`;

const StyledCheck = styled.input`
	position: relative;
	width: 20px;
	height: 20px;
	border-radius: 2px;
	appearance: none;
	transition: all 0.3s;
	border: 1px solid;

	&:before {
		content: "";
		position: absolute;
		border: solid #fff;
		display: block;
		width: 0.3em;
		height: 0.6em;
		border-width: 0 0.2em 0.2em 0;
		z-index: 1;
		opacity: 0;
		right: calc(50% - 0.3em);
		top: calc(50% - 0.6em);
		transform: rotate(0deg);
		transition: all 0.3s;
		transform-origin: center center;
	}

	&:checked {
		animation: ${Check_enter} 0.3s ease-in forwards;
		background-color: #73af55;
		border: none;
	}

	&:checked::before {
		opacity: 1;
		transform: rotate(405deg);
	}
`;

const Checkbox = (props) => {
	return <StyledCheck checked={props.value || props.defaultValue} {...props} type={"checkbox"} />;
};

export default Checkbox;
